import {
  getLanguageJourneyByCode,
  getLanguageJourneyRevision,
  getServerLanguageJourneyRevision,
  preloadLanguageJourney,
  subscribeLanguageJourneys,
} from "@/lib/languageJourneyClient";
import { useCallback, useEffect, useState, useSyncExternalStore } from "react";

/** Subscribes without loading; only an explicit Journey entry requests priority. */
export function useLanguageJourneyCatalog(code?: string | null, required = false) {
  const revision = useSyncExternalStore(
    subscribeLanguageJourneys,
    getLanguageJourneyRevision,
    getServerLanguageJourneyRevision
  );
  const [failure, setFailure] = useState<{ code: string; error: boolean } | null>(null);
  const retry = useCallback(() => {
    if (!code) return;
    setFailure(null);
    void preloadLanguageJourney(code).catch(() => setFailure({ code, error: true }));
  }, [code]);
  useEffect(() => {
    if (required && code && !getLanguageJourneyByCode(code)) retry();
  }, [code, required, retry]);
  return { revision, retry, error: Boolean(failure && failure.code === code && failure.error) };
}
